import React, { ChangeEvent, useState } from 'react';
//assets
import searchImg from "img/search-icon.svg";
import clearSearchImg from "img/cd-close-btn.svg";
//components
import Text from 'components/Text';
import { Row } from 'components/Layout/Grid';
import toast from "components/Toast/dispatch";
import { BackButton } from '../components/generics/BackButton';
//styles
import { SearchInput } from './styles';
import { colors } from '../styles/colors';
import { PageTitle } from '../MapProduct/HeaderMapProduct/styles';
import { FilterButton, InputTitle, SearchContainer } from '../MapProduct/GridMapProduct/SearchArea/styles';
//services
import QuotationService from 'services/quote.service';
import ModalLoader from '../components/generics/Modal/Loader';
import { Visibility } from 'components/Visibility';

export const ManualQuote: React.FC = () => {
  const [filterText, setFilterText] = useState("");
  const [loader, setLoader] = useState(false);

  const disableButtonSearch = filterText.length === 0;
  const _quotationServices = new QuotationService();

  const searchQuotation = async () => {
    setLoader(true);
    const response = await _quotationServices.getWGGByCode(filterText);

    if (response.status === 200)
      toast.success(response.data.message);
    else
      toast.error("Falha ao solicitar a baixa da cotação");

    setLoader(false);
    setFilterText("");
  };

  return (
    <>
      <Visibility visible={loader}>
        <ModalLoader />
      </Visibility>
      <BackButton />

      <PageTitle size={24} className="color-blue-gray">Baixa manual de cotação</PageTitle>

      <InputTitle size={12} className="color-blue-gray">
        Digite o código da cotação e clique em baixar cotação
      </InputTitle>

      <SearchContainer>
        <Row className="flex-1">
          <SearchInput
            type="text"
            value={filterText}
            searchOnClick={() => setFilterText("")}
            icon={filterText.length > 0 ? clearSearchImg : searchImg}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
          />

          <FilterButton disabled={disableButtonSearch} onClick={() => searchQuotation()}>
            <Text color={colors.white}>
              Baixar cotação
            </Text>
          </FilterButton>
        </Row>
      </SearchContainer>
    </>
  );
};